import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { ButtonWithText } from "../../utils/ButtonWithText";
import { CategoryLayer } from "../splash-scene/categories/CategoryLayer";
import { CategoriesContainer } from "../splash-scene/categories/CategoriesContainer";

export class UnlockedLevelContainer extends Phaser.GameObjects.Container {

    public static currentInstance: UnlockedLevelContainer;

    private rewardedAdsButton: ButtonWithText;
    private extraBoardThumb: Phaser.GameObjects.Image;
    private extraBoardName: Phaser.GameObjects.Text;
    private rays: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        UnlockedLevelContainer.currentInstance = this;
        
        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        this.y = -100;

        const unlockedLabel = new Phaser.GameObjects.Text(this.scene, -128, 30, gameText.BOARD_CLEARED[lan], {fontFamily: "Arial", fontSize: "22px", color: "#7C5D46", fontStyle: "bold"});
        unlockedLabel.setOrigin(.5);
        unlockedLabel.scaleX = .8;
        this.add(unlockedLabel);

        const category = GameVars.boardsData[GameVars.levelIndex].cat;

        const index = CategoryLayer.CATEGORIES.indexOf(category) + 1;
        const key = CategoriesContainer.CATEGORIES_DATA[index - 1].key;

        let categoryStr = gameText[key][lan];
        categoryStr = categoryStr.charAt(0).toUpperCase() + categoryStr.slice(1).toLowerCase();

        const categoryImg = new Phaser.GameObjects.Image(scene, -215, 256, "texture_atlas_1", "icon_" + index);
        this.add(categoryImg);

        const categoryLabel = new Phaser.GameObjects.Text(this.scene, -124, categoryImg.y + 2, categoryStr, {fontFamily: "OpenSans-CondLight", fontSize: "32px", color: "#FFF4A8"});
        categoryLabel.setOrigin(.5);
        this.add(categoryLabel);

        const id = GameVars.boardsData[GameVars.levelIndex].id;

        const atlasTexture = this.scene.textures.get("texture_atlas_2");
        let textureAtlas = atlasTexture.has(id) ? "texture_atlas_2" : "texture_atlas_3";

        const w = 180;
        const h = 156;
        const r = 8;

        let backgroundThumb = new Phaser.GameObjects.Graphics(this.scene);
        backgroundThumb.fillStyle(0xfffffb);
        backgroundThumb.fillRoundedRect(-w / 2, -35, w, h, r);
        backgroundThumb.x = -132;
        backgroundThumb.y = 90;
        this.add(backgroundThumb);

        const thumb = new Phaser.GameObjects.Image(scene, backgroundThumb.x, backgroundThumb.y + h / 2 - 48, textureAtlas, id);
        thumb.setScale(.96);
        this.add(thumb);

        const name = new Phaser.GameObjects.Text(scene, thumb.x, thumb.y + 74, GameVars.boardsData[GameVars.levelIndex].name, {fontFamily: "OpenSans-CondLight", fontSize: "42px", color: "#7C5D46"});
        name.setOrigin(.5);
        this.add(name);

        let height = name.height;
        let width = name.width; 

        name.setScale(28 / height);

        width *= 28 / height;

        if (width > 140) {
            name.setScale(140 / name.width);
        }

        // LA IMAGEN DEL NIVEL POR DESBLOQUEAR

        this.rays = new Phaser.GameObjects.Image(scene, 132, 130, "texture_atlas_4", "new_board_rays");
        this.rays.setScale(1.65);
        this.add(this.rays);

        this.scene.tweens.add({
            targets: this.rays,
            angle: 360,
            duration: 20000,
            ease: Phaser.Math.Easing.Linear,
            repeat: -1
        });

        backgroundThumb = new Phaser.GameObjects.Graphics(this.scene);
        backgroundThumb.fillStyle(0xfffffb);
        backgroundThumb.fillRoundedRect(-w / 2, -35, w, h, r);
        backgroundThumb.x = 132;
        backgroundThumb.y = 90;
        this.add(backgroundThumb);

        this.extraBoardThumb = new Phaser.GameObjects.Image(scene, backgroundThumb.x, backgroundThumb.y + h / 2 - 48, "texture_atlas_1", "locked_level");
        this.extraBoardThumb.setScale(.95);
        this.add(this.extraBoardThumb);

        this.extraBoardName = new Phaser.GameObjects.Text(scene, this.extraBoardThumb.x, this.extraBoardThumb.y + 74, gameText.EXTRA_BOARD[lan], {fontFamily: "OpenSans-CondLight", fontSize: "24px", color: "#7C5D46"});
        this.extraBoardName.setOrigin(.5);
        this.add(this.extraBoardName);

        if (this.extraBoardName.width > 165) {
            this.extraBoardName.setScale(165 / this.extraBoardName.width);
        }

        const rewardedAdButtonImg = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_extra_hints");
        rewardedAdButtonImg.setScale(1.35);

        const rewardedAdButtonLabel = new Phaser.GameObjects.Text(this.scene, -16, 0, gameText.GET_1_NEW_BOARD[lan], {fontFamily: "OpenSans-CondLight", fontSize: 19, color: "#FFFFFF"});
        rewardedAdButtonLabel.setOrigin(.5);

        this.rewardedAdsButton = new ButtonWithText(this.scene, rewardedAdButtonImg, rewardedAdButtonLabel, this.onClickRewardedAdsButton, this);
        this.rewardedAdsButton.x = 132;
        this.rewardedAdsButton.y = 260;
        this.add(this.rewardedAdsButton);

        this.scene.tweens.add({
            targets: this.rewardedAdsButton,
            scaleX: 1.125,
            scaleY: 1.125,
            duration: 1000,
            ease: Phaser.Math.Easing.Linear,
            yoyo: true,
            repeat: -1
        });
    }

    public onRewardedAdSuccess(): void {

        if (GameVars.unlockedBoardIndex !== null) {

            this.rays.destroy();
 
            const unlockedLevelContainer = new Phaser.GameObjects.Container(this.scene);
            this.add(unlockedLevelContainer);
    
            const id = GameVars.boardsData[GameVars.unlockedBoardIndex].id;
           
            const atlasTexture = this.scene.textures.get("texture_atlas_2");
            let textureAtlas = atlasTexture.has(id) ? "texture_atlas_2" : "texture_atlas_3";
    
            this.extraBoardThumb.setTexture(textureAtlas, id);

            this.extraBoardName.text = GameVars.boardsData[GameVars.unlockedBoardIndex].name;
    
            let height = this.extraBoardName.height;
            let width = this.extraBoardName.width; 
    
            this.extraBoardName.setScale(28 / height);
    
            width *= 28 / height;
    
            if (width > 140) {
                this.extraBoardName.setScale(140 / this.extraBoardName.width);
            }

        } else {

            // mostrar mensaje de q todos los niveles ya estan abiertos
            const errorLabel = new Phaser.GameObjects.Text(this.scene, 0, 320, "SORRY, ALL BOARDS UNLOCKED", {fontFamily: "OpenSans-CondLight", fontSize: "30px", color: "#FFF4A8"});
            errorLabel.setOrigin(.5);
            this.add(errorLabel);
        }
    }

    public onRewardedAdFail(): void {
        //
    }

    private onClickRewardedAdsButton(): void {
        
        this.rewardedAdsButton.visible = false;

        GameManager.unlockRandomBoard();
    }
}
